import React from "react";
import {
  Grid, GridItem, ClipboardCopy, Content, Tooltip
} from '@patternfly/react-core';
import { CONFIG } from '../../../../../config/config'
import { Icons } from 'shared/components/Icons/index'

const MountStorageInfoPublic = ({
  context,
  nfs_exports,
  userProfile,
  iscsi_target
}) => {
  const smb_win_command_public = `net use Y: \\\\${CONFIG.SMB_IP}\\public /user:${userProfile.username} *`
  const smb_lin_command_public = `mount -t cifs //${CONFIG.SMB_IP}/public /mnt/public -o username=${userProfile.username}`
  return (
    <>
      <br />
      <Grid
        hasGutter
        span={12}
        style={{
          fontSize: "13px",
          lineHeight: "1.6"
        }}
      >
        <>
          <GridItem span={12}>
            <Content component="h6">Montowanie udziałów publicznych</Content>
            <table className="table">
              <tbody>
                <tr>
                  <th>OS</th>
                  <th>Sieć</th>
                  <th>Protokół</th>
                  <th style={{ textAlign: "right" }}>Polecenie montowania</th>
                </tr>
                {/* WIN */}
                <tr>
                  <td>
                    <Tooltip content={<div>Windows</div>}>
                      {Icons.Windows}
                    </Tooltip>
                  </td>
                  <td>LAN</td>
                  <td>SMB</td>
                  <td className="small">
                    <ClipboardCopy
                      copyAriaLabel="Copy inline compact example"
                      hoverTip="Kopiuj"
                      clickTip="Skopiowano"
                      variant="inline-compact"
                    >
                      {smb_win_command_public}
                    </ClipboardCopy>
                  </td>
                </tr>
                {/* LINUX */}
                <tr>
                  <td>
                    <Tooltip content={<div>Linux</div>}>
                      {Icons.Linux}
                    </Tooltip>
                  </td>
                  <td>LAN</td>
                  <td>SMB</td>
                  <td className="small">
                    <ClipboardCopy
                      copyAriaLabel="Copy inline compact example"
                      hoverTip="Kopiuj"
                      clickTip="Skopiowano"
                      variant="inline-compact"
                    >
                      {smb_lin_command_public}
                    </ClipboardCopy>
                  </td>
                </tr>
              </tbody>
            </table>
          </GridItem>
        </>
      </Grid>
    </>
  );
};

export default MountStorageInfoPublic;